export const routes = {
  home: '/',
  login: '/login',
  register: '/register',
  otp: '/otp',
  referralCode: '/referral-code',
  referFriend: '/refer-friend',
  registerSuccess: '/register-success',
  addToWallet: '/add-to-wallet',
  couponDetail: '/coupon-detail',
} as const;

export const publicRoutes = [
  routes.login,
  routes.register,
  routes.otp,
  routes.referralCode,
  routes.registerSuccess,
  routes.addToWallet,
] as const;

export const protectedRoutes = [
  routes.home,
  routes.referFriend,
  routes.couponDetail,
] as const;

// Type for route names
export type RouteName = keyof typeof routes;

// Helper function to get route path
export const getRoute = (routeName: RouteName): string => {
  return routes[routeName];
};

// Helper function to check if route is public
export const isPublicRoute = (pathname: string): boolean => {
  return publicRoutes.includes(pathname as any);
};

// Helper function to check if route is protected
export const isProtectedRoute = (pathname: string): boolean => {
  return protectedRoutes.includes(pathname as any);
}; 